export const VIDEO_UPLOAD_ENABLED = process.env.REACT_APP_VIDEO_UPLOAD_ENABLED === "true";